import React from 'react';
import { Row, Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

/**
 *
 */
class Layout_three_feat  extends Layout_base {
  render() {
    return (
      <Col xs={12} className="promo home-banner generic__feat">
        {this.sectionHead()}
        <Row>
          <Col xs={12} lg={8}>
            {this.componentDOM(0)}
          </Col>
          <Col xs={12} lg={4} className="banner-xs">
            <div className="top-banner">
              {this.componentDOM(1)}
            </div>
            <div className="bottom-banner">
              {this.componentDOM(2)}
            </div>
          </Col>
        </Row>
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_three_feat;
